import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

export default function Layout({ children, sidebarKey }) {
  return (
    <>
      {/* Fixed Navbar */}
      <Navbar />

      {/* Sidebar fixed on md and larger, normal flow on small screens */}
      <div className="flex pt-12 min-h-screen">
        {/* Sidebar */}
        <div
          className={`
            w-full md:w-64
            md:fixed md:top-14 md:left-0 md:h-[calc(100vh-64px)]
            z-40
          `}
        >
          <Sidebar key={sidebarKey} />
        </div>

        {/* Main content */}
        <main className="flex-1 p-8 ml-0 md:ml-64 bg-gray-100 min-h-screen">
          {children}
        </main>
      </div>
    </>
  );
}